import { t } from '@lingui/macro';
const isValidEmail = (value) => {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(value).toLowerCase());
};
const validateEmail = (value, index, array) => {
    let errorMessage;
    if (!value) {
        errorMessage = t `Email cannot be empty. Fill it in or remove.`;
    }
    else if (!isValidEmail(value)) {
        errorMessage = t `"${value}" is not a valid email address`;
    }
    else {
        errorMessage = array.indexOf(value) !== index ? t `${value} already exists` : undefined;
    }
    return { key: index, errorMessage };
};
export { validateEmail, isValidEmail };
